import { PropTypes } from 'prop-types'

const addressShape = PropTypes.shape({
  addressId: PropTypes.string,
  addressType: PropTypes.string,
  city: PropTypes.string.isRequired,
  complement: PropTypes.string,
  country: PropTypes.string.isRequired,
  geoCoordinates: PropTypes.arrayOf(PropTypes.number),
  neighborhood: PropTypes.string.isRequired,
  number: PropTypes.string,
  postalCode: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  street: PropTypes.string.isRequired,
})

export { addressShape }
